import { createSelector } from "@reduxjs/toolkit";
import { createLoaderSelector } from "helpers/selectLoader";
import { selectPricingState } from ".";

// Selectors spécifiques exportés (API publique)
export const selectPricingPageLoading = createLoaderSelector(selectPricingState, 'pricingPageLoading');
export const selectContractFunnelsLoading = createLoaderSelector(selectPricingState, 'contractFunnelsLoading');
export const selectContractFunnelsPricesLoading = createLoaderSelector(selectPricingState, 'contractFunnelsPricesLoading');
export const selectQuoteCreationLoading = createLoaderSelector(selectPricingState, 'quoteCreationLoading');

/**
 * Vrai dès qu'un re-tarif global est en cours (reload complet, garanties globales, ou variables/frais).
 * Source de vérité unique pour : afficher le loader sur les cartouches ET bloquer panier / devis.
 */
export const selectIsPricingBusy = createSelector(
  selectPricingState,
  (state) =>
    state.loading.pricingPageLoading ||
    state.loading.contractFunnelsLoading ||
    state.loading.contractFunnelsPricesLoading
);

